// extracted by mini-css-extract-plugin
export var barContainer = "_53-0";
export var extraThin = "_53-3";
export var fillBar = "_53-6";
export var fillContainer = "_53-4";
export var overflow = "_53-8";
export var overflowContainer = "_53-5";
export var regular = "_53-7";
export var thick = "_53-1";
export var thin = "_53-2";